<!-- Button -->
<button
    class="relative flex items-center justify-center w-9 h-9 rounded-lg border border-white/10 hover:border-white/20 hover:bg-white/[0.06] transition-all duration-150 cursor-pointer"
    [matMenuTriggerFor]="languages">
    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: activeLang}"></ng-container>
</button>

<!-- Language menu -->
<mat-menu
    [xPosition]="'before'"
    #languages="matMenu">
    @for (lang of availableLangs; track $index) {
        <ng-container>
            <button
                mat-menu-item
                (click)="setActiveLang(lang)">
                <span class="flex items-center">
                    <ng-container *ngTemplateOutlet="flagImage; context: {$implicit: lang}"></ng-container>
                    <span class="mx-2 text-sm">{{ getLabel(lang) }}</span>
                </span>
            </button>
        </ng-container>
    }
</mat-menu>

<!-- Flag image template -->
<ng-template
    let-lang
    #flagImage>
    <span class="relative w-5 h-3.5 rounded-[2px] overflow-hidden shadow-sm ring-1 ring-black/5">
        <img
            class="w-full h-full object-cover"
            [src]="'assets/images/flags/' + flagCodes[lang] + '.svg'"
            [alt]="'Flag image for ' + lang">
    </span>
</ng-template>
